// State store — pass merged PDF Blob between editor and result pages,
// and pre-selected Files between landing and editor pages.
// Architecture: see /ARCHITECTURE.md

const KEY_BLOB_URL = "mergepdf:blobUrl";
const KEY_META = "mergepdf:meta";

export interface MergeMeta {
  fileName: string;       // suggested download name
  sizeBytes: number;
  pageCount: number;
  sourceCount: number;
  createdAt: number;
}

let currentUrl: string | null = null;
let pendingFiles: File[] = [];

export function setPendingFiles(files: File[]): void {
  pendingFiles = files.slice(0, 6); // hard cap at 6
}

export function getPendingFiles(): File[] {
  return pendingFiles;
}

export function clearPendingFiles(): void {
  pendingFiles = [];
}

export function storeMergedPdf(blob: Blob, meta: MergeMeta): void {
  // Revoke any previous URL so we don't leak Object URLs across runs.
  if (currentUrl) URL.revokeObjectURL(currentUrl);
  currentUrl = URL.createObjectURL(blob);
  sessionStorage.setItem(KEY_BLOB_URL, currentUrl);
  sessionStorage.setItem(KEY_META, JSON.stringify(meta));
}

export function getMergedPdfUrl(): string | null {
  if (currentUrl) return currentUrl;
  const stored = sessionStorage.getItem(KEY_BLOB_URL);
  if (stored) {
    currentUrl = stored;
    return stored;
  }
  return null;
}

export function getMergedPdfMeta(): MergeMeta | null {
  const raw = sessionStorage.getItem(KEY_META);
  return raw ? (JSON.parse(raw) as MergeMeta) : null;
}

export function clearMergedPdf(): void {
  if (currentUrl) {
    URL.revokeObjectURL(currentUrl);
    currentUrl = null;
  }
  sessionStorage.removeItem(KEY_BLOB_URL);
  sessionStorage.removeItem(KEY_META);
}

// Revoke on tab close to free memory
if (typeof window !== "undefined") {
  window.addEventListener("beforeunload", () => {
    if (currentUrl) URL.revokeObjectURL(currentUrl);
  });
}
